<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <worker-check-in-page /><br><br><br>
    </div>
  </div>
</template>

<script>
import WorkerCheckInPage from '../../../Components/Worker/WorkerCheckInPage.vue';
  export default {
    name: 'WorkerCheckIn',
    components: {
      'worker-check-in-page': WorkerCheckInPage,
    },
  };
</script>

<style scoped>

</style>
